import LoaderSpiner from "../../../components/loaderSpiner";
import React, { useEffect, useState } from "react";
import Dropdown from "../../../components/Dropdown";
import { useNavigate } from "react-router-dom";
import UpdatePopup from "./UpdatePopup";
import { useBlockPackingMutation, useLazyGetSavedPackingListQuery, useUnSavePackingListMutation } from "../../../services/Api";
import { toast } from "react-toastify";
import { Pagination } from "../../../components/Pagination";

const TravellerPackingList = () => {
    const [dropdownActive, setDropdownActive] = useState(null);
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
    const [unSavePackingList, { isLoading, isError, isSuccess }] = useUnSavePackingListMutation();
    const [trigger, { data, isLoading: loading }] = useLazyGetSavedPackingListQuery();
    const [currentPage, setCurrentPage] = useState(1);
    const handleBlockPacking = async (id) => {
        try {
            const response = await unSavePackingList({ id });
            toast.success(response?.message);
            trigger();
        } catch (error) {
        }
    };
    useEffect(() => {
        trigger({ page: currentPage });
    }, [currentPage]);
    const navigate = useNavigate();
    const toggleDropdown = (index) => {
        setDropdownActive((prev) => (prev === index ? null : index));
    };

    const openUpdatePopup = (item) => {
        setIsUpdateModalOpen(true);
        setSelectedItem(item);
        setDropdownActive(null);
    };

    const closeUpdatePopup = () => {
        setIsUpdateModalOpen(false);
        setSelectedItem(null);
    };

    const openDeletePopup = (item) => {

        setIsDeleteModalOpen(true);
        setSelectedDeleteItem(item);
        setDropdownActive(null);
    };

    const closeDeletePopup = () => {
        setIsDeleteModalOpen(false);
        setSelectedDeleteItem(null);
    };

    const handleDelete = () => {
        closeDeletePopup();
    };
    return (
        <div className="sm:px-8 px-6 pb-5">
            <div className="grid my-4  grid-cols-1 gap-3 whitespace-nowrap">
                <h2 className='text-black font-roboto-mono text-[20px] font-bold' >
                    Traveller Saved Packing List
                </h2>

            </div>
            <div className="grid md:grid-cols-2">
                <div className="md:col-span-2 bg-white p-6 rounded-[1.75rem] shadow-md mb-4 md:mb-0 h-fit">
                    <h2 className="mb-4 font-['Roboto_Mono'] text-2xl font-bold">
                        Traveller Saved Packing List Table
                    </h2>
                    <div className="overflow-x-auto">
                        <table className="w-full table-auto border-separate border-spacing-y-4">
                            <thead>
                                <tr className="bg-tablecolor">
                                    <th className="p-3 text-center align-middle w-8 rounded-l-xl border-l border-t border-b border-solid border-bordercolor">
                                        <input type="checkbox" className="rounded border-gray-300" />
                                    </th>
                                    <th className="p-3 text-center align-middle text-black text-sm font-['Roboto_Mono'] text-[14px] font-medium border-t border-b border-solid border-bordercolor">
                                        ID
                                    </th>
                                    <th className="p-3 text-center align-middle text-black text-sm font-['Roboto_Mono'] text-[14px] font-medium border-t border-b border-solid border-bordercolor">
                                        Title
                                    </th>
                                    <th className="p-3 text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm border-t border-b border-solid border-bordercolor">
                                        Type
                                    </th>
                                    <th className="p-3 whitespace-nowrap text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm border-t border-b border-solid border-bordercolor">
                                        Destination
                                    </th>
                                    <th className="p-3 whitespace-nowrap text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm border-t border-b border-solid border-bordercolor">
                                        Climate
                                    </th>
                                    <th className="p-3 text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm w-20 border-t border-b border-solid border-bordercolor">
                                        Duration
                                    </th>
                                    <th className="p-3 whitespace-nowrap text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm border-t border-b border-solid border-bordercolor">
                                        Body Type
                                    </th>
                                    <th className="p-3 whitespace-nowrap text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm border-t border-b border-solid border-bordercolor">
                                        Packing Style
                                    </th>
                                    <th className="p-3 text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm w-20 border-t border-b border-solid border-bordercolor">
                                        Tags
                                    </th>
                                    <th className="p-3 text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm w-20 border-t border-b border-solid border-bordercolor">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {loading ? (
                                    <></>
                                ) : (
                                    data?.data?.map((items, index) => (
                                        <tr
                                            key={index}
                                            className="bg-white hover:bg-tablecolor rounded-xl"
                                        >
                                            <td className="p-3 text-center align-middle rounded-l-xl border-l border-t border-b border-solid border-bordercolor">
                                                <input
                                                    type="checkbox"
                                                    className="rounded border-normalGray"
                                                />
                                            </td>
                                            <td className="p-3 text-center align-middle text-normalGray border-t border-b border-solid font-quicksand text-sm font-semibold border-bordercolor">
                                                {items?._id}
                                            </td>
                                            <td className="p-3 text-center align-middle text-normalGray border-t border-b border-solid font-quicksand text-sm font-semibold border-bordercolor">
                                                {items?.title}
                                            </td>
                                            <td className="py-2 px-3 text-center align-middle border-t border-b border-solid border-bordercolor">
                                                <span
                                                    className={`block w-fit py-[2px] px-2 rounded-md ${items.type === "PRO"
                                                        ? "bg-[#D9DCB0] text-black font-semibold text-sm"
                                                        : "bg-gray-200 text-gray-600 font-semibold text-sm"
                                                        }`}
                                                >
                                                    {items?.type}
                                                </span>
                                            </td>
                                            <td className="p-3 text-center align-middle text-black font-quicksand text-[12px] font-semibold text-sm border-t border-b border-solid border-bordercolor">
                                                {items?.destinations?.map((dest, idx) => (
                                                    <span key={idx} className="items-center">
                                                        {dest?.region} {dest?.country} {dest?.state} {dest?.city},{" "}
                                                    </span>
                                                ))}
                                            </td>
                                            <td className="p-3 text-center align-middle text-normalGray font-quicksand text-sm font-semibold border-t border-b border-solid border-bordercolor">
                                                {items?.climate?.map((item, index) => (
                                                    <span key={index}>{item?.climateType}, </span>
                                                ))}
                                            </td>
                                            <td className="p-3 text-center align-middle text-normalGray font-quicksand text-sm font-semibold border-t border-b border-solid border-bordercolor">
                                                {items?.duration}
                                            </td>
                                            <td className="p-3 text-center align-middle text-normalGray font-quicksand text-sm font-semibold border-t border-b border-solid border-bordercolor">
                                                {items?.bodyType}
                                            </td>
                                            <td className="p-3 text-center align-middle text-normalGray font-quicksand text-sm font-semibold border-t border-b border-solid border-bordercolor">
                                                {items?.packingStyle}
                                            </td>
                                            <td
                                                className={`p-3 text-center align-middle text-normalGray font-quicksand text-sm font-semibold border-t border-b border-solid border-bordercolor`}
                                            >
                                                <span
                                                    className={`p-2 rounded-md ${items?.isBlocked
                                                        ? "bg-errorcolor text-white"
                                                        : "bg-bgprimary text-dark"
                                                        }`}
                                                >
                                                    {items?.isBlocked ? "Block" : "Active"}
                                                </span>
                                            </td>
                                            <td className="p-3 text-center align-middle rounded-r-xl border-r border-t border-b border-solid border-bordercolor">
                                                <Dropdown
                                                    active={dropdownActive === index}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleDropdown(index);
                                                    }}
                                                    options={[
                                                        {
                                                            label: "View",
                                                            onClick: (e) => {
                                                                e.stopPropagation();
                                                                navigate(`/trip-detail/${items?._id}`);
                                                            },
                                                        },
                                                        {
                                                            label: "Unsave",
                                                            onClick: (e) => {
                                                                e.stopPropagation();
                                                                handleBlockPacking(items?._id, "6months");
                                                                toggleDropdown(index);
                                                            },
                                                        },


                                                    ]}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>

                        {loading && (
                            <div className="relative h-[30vh] w-full">
                                <LoaderSpiner />
                            </div>
                        )}

                        {isUpdateModalOpen && (
                            <UpdatePopup item={selectedItem} onClose={closeUpdatePopup} />
                        )}

                        {isDeleteModalOpen && (
                            <div className="fixed inset-0 flex items-center justify-center bg-opacity-50 bg-black z-50">
                                <div className="text-center bg-white rounded-lg p-6 w-[20rem] shadow-lg relative">
                                    <p className="mb-4">Are you sure you want to delete this item?</p>
                                    <button
                                        className="bg-errorcolor text-white px-4 py-2 rounded mr-2"
                                        onClick={handleDelete}
                                    >
                                        Delete
                                    </button>
                                    <button
                                        className="bg-gray-300 px-4 py-2 rounded"
                                        onClick={closeDeletePopup}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="overflow-x-auto">
                        <Pagination
                            totalPages={data?.pagination?.totalPages}
                            currentPage={currentPage}
                            onPageChange={setCurrentPage}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TravellerPackingList

